import { Text } from '@consta/uikit/Text'
import { For, Show } from '@library/components'
import type { MaybeIconType } from '@library/shared'
import { createColor, getIcon } from '@library/shared'
import cn from 'classnames'
import { forwardRef } from 'react'

import css from './Ghost.css'

const MAX_INDEX = 3
const MAX_INDEX_STYLE = { '--max-index': MAX_INDEX }

export const GHOST_OFFSET = -20

export type GhostProps = {
  icon: MaybeIconType
  color?: string
  name: string
  className?: string
  count?: number
}

export const Ghost = forwardRef<HTMLDivElement, GhostProps>(function Ghost(
  { icon, name, color, className: externalClass = '', count },
  ref,
) {
  const Icon = getIcon(icon)

  const className = cn(css.ghost, externalClass)
  const showCount = count !== undefined && count > 1
  const repeats = Math.min(count ?? 1, MAX_INDEX)

  return (
    <div ref={ref} className={cn(css.container, css.hide)} style={MAX_INDEX_STYLE}>
      <Show when={showCount}>
        <div className={css.count}>{count}</div>
      </Show>
      <For each={Array.from({ length: repeats })}>
        {(_, index) => (
          <div key={index} className={className} style={{ '--index': index }}>
            <div className={css.iconContainer} style={createColor(color)}>
              {!!Icon && <Icon size="m" />}
            </div>
            <Text className={css.text} size="s">
              {name}
            </Text>
          </div>
        )}
      </For>
    </div>
  )
})
